import { ChevronRight, Sparkles } from "lucide-react";
import { openBookingModal } from "../lib/bookingModal";

// Compact, premium "Best Rate Today" badge for the homepage.
//
// STRICT DATA POLICY (per client rule #6 "Safe Fallback"):
//   • Little Hotelier does NOT expose a public API for property owners to
//     retrieve today's bookable rate from their own site. Until a genuine
//     SiteMinder Distribute / Partner API integration is configured we do
//     NOT display any $ amount here — showing a hard-coded, estimated, or
//     scraped price would violate the client's "no fake data" policy.
//   • Wording is neutral & honest: "Check Today's Rates & Availability".
//   • The "Check Availability →" CTA opens the existing Little Hotelier
//     handoff (booking modal → engine) so guests always land on the real,
//     current live rate on Little Hotelier itself.
//
// When SiteMinder API credentials are provided in future, wire the live
// amount into this component behind a feature flag — do not remove this
// safe fallback path.

export default function BestRateBadge() {
  return (
    <section
      data-testid="best-rate-badge"
      aria-label="Book direct with Byer Fountain Motor Inn"
      className="bg-[#F7F5F0] pt-12 pb-4"
    >
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="relative overflow-hidden rounded-2xl bg-[#0B192C] text-white soft-shadow border border-[#D4AF37]/30 flex flex-col sm:flex-row items-start sm:items-center gap-4 sm:gap-6 px-5 sm:px-7 py-5">
          <span className="absolute -right-8 -top-10 w-40 h-40 rounded-full bg-[#D4AF37]/10 blur-3xl pointer-events-none" />

          <div className="flex items-center gap-3 relative">
            <span className="w-10 h-10 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#b8932c] grid place-items-center text-[#0B192C] shrink-0">
              <Sparkles size={18} />
            </span>
            <div>
              <p className="overline text-[#D4AF37] leading-none mb-1" data-testid="best-rate-eyebrow">Book Direct</p>
              <p className="font-serif text-2xl md:text-[26px] leading-tight" data-testid="best-rate-title">
                Check Today&apos;s Rates &amp; Availability
              </p>
            </div>
          </div>

          <p className="text-white/60 text-sm sm:text-[13px] sm:max-w-xs relative">
            Live rates and availability are provided by our secure booking engine — no fees, no middlemen, direct to reception.
          </p>

          <button
            onClick={() => openBookingModal()}
            data-testid="best-rate-cta"
            className="ml-auto group inline-flex items-center gap-2 bg-[#D4AF37] text-[#0B192C] hover:bg-white transition-colors px-5 py-3 rounded-full font-medium text-sm shrink-0"
          >
            Check Availability
            <ChevronRight size={16} className="group-hover:translate-x-1 transition-transform" />
          </button>
        </div>
      </div>
    </section>
  );
}
